export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string; allowedRoles?: string[] }
  children?: INavigationRoute[]
}

import { getUserRole } from '../../utils/userRoleUtils'

const userRole = getUserRole()
const filterRoutesByRole = (routes: INavigationRoute[], role: string): INavigationRoute[] => {
  return routes
    .filter((route) => {
      if (route.meta.allowedRoles && route.meta.allowedRoles.includes(role)) {
        return true
      }
      if (!route.meta.allowedRoles) {
        return true
      }
      return false
    })
    .map((route) => {
      if (route.children) {
        route.children = filterRoutesByRole(route.children, role)
      }
      return route
    })
}

const sidebarRoutes = {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: filterRoutesByRole(
    [
      {
        name: 'dashboard',
        displayName: 'Executive Dashboard',
        meta: {
          icon: 'dashboard',
          allowedRoles: ['owner'],
        },
        children: [
          {
            name: 'dashboard',
            displayName: 'Overview',
            meta: {
              icon: 'overview',
              allowedRoles: ['owner'],
            },
          },
          {
            name: 'analytics',
            displayName: 'Analytics',
            meta: {
              icon: 'analytics',
              allowedRoles: ['owner'],
            },
          },
          {
            name: 'reports',
            displayName: 'Reports',
            meta: {
              icon: 'assessment',
              allowedRoles: ['owner'],
            },
          },
          {
            name: 'odometer-reports',
            displayName: 'Odometer Reports',
            meta: {
              icon: 'speed',
              allowedRoles: ['owner'],
            },
          },
          {
            name: 'charging-reports',
            displayName: 'Charging Reports',
            meta: {
              icon: 'battery_charging_full',
              allowedRoles: ['owner'],
            },
          },
        ],
      },
      {
        name: 'organization',
        displayName: 'Organization',
        meta: {
          icon: 'business',
          allowedRoles: ['owner'],
        },
        children: [
          {
            name: 'users',
            displayName: 'All Users',
            meta: {
              icon: 'group',
              allowedRoles: ['owner'],
            },
          },
          {
            name: 'operators',
            displayName: 'Operators',
            meta: {
              icon: 'support_agent',
              allowedRoles: ['owner'],
            },
          },
          {
            name: 'role-management',
            displayName: 'Role Management',
            meta: {
              icon: 'security',
              allowedRoles: ['owner'],
            },
          },
          {
            name: 'user-management',
            displayName: 'User Management',
            meta: {
              icon: 'admin_panel_settings',
              allowedRoles: ['owner'],
            },
          },
        ],
      },
      {
        name: 'fleet-management',
        displayName: 'Fleet Management',
        meta: {
          icon: 'commute',
          allowedRoles: ['owner'],
        },
        children: [
          {
            name: 'drivers',
            displayName: 'Drivers',
            meta: {
              icon: 'moped',
              allowedRoles: ['owner'],
            },
          },
          {
            name: 'our-drivers',
            displayName: 'Our Drivers',
            meta: {
              icon: 'person',
              allowedRoles: ['owner'],
            },
          },
          {
            name: 'vehicles',
            displayName: 'Vehicles',
            meta: {
              icon: 'directions_car',
              allowedRoles: ['owner'],
            },
          },
          {
            name: 'our-vehicles',
            displayName: 'Our Vehicles',
            meta: {
              icon: 'directions_car',
              allowedRoles: ['owner'],
            },
          },
          {
            name: 'bikes',
            displayName: 'Bikes',
            meta: {
              icon: 'two_wheeler',
              allowedRoles: ['owner'],
            },
          },
          {
            name: 'trips',
            displayName: 'Trips',
            meta: {
              icon: 'route',
              allowedRoles: ['owner'],
            },
          },
          {
            name: 'alarms',
            displayName: 'Alarms',
            meta: {
              icon: 'notifications',
              allowedRoles: ['owner'],
            },
          },
        ],
      },
      {
        name: 'operations',
        displayName: 'Operations',
        meta: {
          icon: 'engineering',
          allowedRoles: ['owner'],
        },
        children: [
          {
            name: 'maintenance',
            displayName: 'Maintenance',
            meta: {
              icon: 'build',
              allowedRoles: ['owner'],
            },
          },
          {
            name: 'maintenance-items',
            displayName: 'Maintenance Items',
            meta: {
              icon: 'inventory',
              allowedRoles: ['owner'],
            },
          },
          {
            name: 'maintenance-workshops',
            displayName: 'Workshops',
            meta: {
              icon: 'business',
              allowedRoles: ['owner'],
            },
          },
          {
            name: 'tickets',
            displayName: 'Tickets',
            meta: {
              icon: 'assignment',
              allowedRoles: ['owner'],
            },
          },
        ],
      },
      {
        name: 'finance',
        displayName: 'Finance',
        meta: {
          icon: 'account_balance',
          allowedRoles: ['owner'],
        },
        children: [
          {
            name: 'billing',
            displayName: 'Billing',
            meta: {
              icon: 'receipt',
              allowedRoles: ['owner'],
            },
          },
          {
            name: 'pricing-plans',
            displayName: 'Pricing Plans',
            meta: {
              icon: 'attach_money',
              allowedRoles: ['owner'],
            },
          },
        ],
      },
      {
        name: 'settings',
        displayName: 'Settings',
        meta: {
          icon: 'settings',
          allowedRoles: ['owner'],
        },
      },
      {
        name: 'preferences',
        displayName: 'Profile',
        meta: {
          icon: 'manage_accounts',
          allowedRoles: ['owner'],
        },
      },
    ],
    userRole,
  ),
}

export default sidebarRoutes
